import React, { useState, useEffect, useRef } from "react";
import { Box, Card, CardContent, Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { gettingOvertimebyId } from "utils/Overtime";
import Draggable from 'react-draggable';
import dayjs from "dayjs";

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const InfoOvertime = ({ open, setOpen, selectedRow, setSelectedRow, setSelected }) => {
    const { t } = useTranslation();

    const [loadingInfoOvertime, setLoadingInfoOvertime] = useState(true);
    const [overtimes, setOvertime] = useState({});
    const validity_period_data = {
        'day': t("settings.overtimes.dialog.fields.validity_period_data.day"),
        'week': t("settings.overtimes.dialog.fields.validity_period_data.week"),
        'fortnight': t("settings.overtimes.dialog.fields.validity_period_data.fortnight"),
    }

    const weeks = {
        "monday": t("settings.overtimes.dialog.fields.restart_week_data.monday"),
        "tuesday": t("settings.overtimes.dialog.fields.restart_week_data.tuesday"),
        "wednesday": t("settings.overtimes.dialog.fields.restart_week_data.wednesday"),
        "thursday": t("settings.overtimes.dialog.fields.restart_week_data.thursday"),
        "friday": t("settings.overtimes.dialog.fields.restart_week_data.friday"),
        "saturday": t("settings.overtimes.dialog.fields.restart_week_data.saturday"),
        "sunday": t("settings.overtimes.dialog.fields.restart_week_data.sunday")
    }


    useEffect(() => {
        if (open) {
            gettingOvertimebyId(setLoadingInfoOvertime, selectedRow[0].id)
                .then((response) => {
                    setOvertime(response);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setLoadingInfoOvertime(false);
                });
        }
    }, [selectedRow, open]);

    const closed = () => {
        setOpen(false);
        setLoadingInfoOvertime(true);
        setOvertime({});
        setSelectedRow([]);
        setSelected([]);
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth={"sm"}
            fullWidth
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle id="info-overtime-dialog-title">{t("settings.overtimes.titles.info")}</DialogTitle>
            <DialogContent>
                {loadingInfoOvertime ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <Card>
                        <CardContent>
                            <Box>
                                <Typography variant="body1">
                                    {t("settings.overtimes.dialog.fields.name")}: {overtimes.name}
                                </Typography>
                                <Typography variant="body1">
                                    {t("settings.overtimes.dialog.fields.overtime_start")}: {overtimes.overtime_start}
                                </Typography>
                                <Typography variant="body1">
                                    {t("settings.overtimes.dialog.fields.min_hour_calification")}: {overtimes.min_hour_calification}
                                </Typography>
                                <Typography variant="body1">
                                    {t("settings.overtimes.dialog.fields.required_approval")}: {overtimes.required_approval ? t("general.buttons.yes") : t("general.buttons.no")}
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        t("settings.overtimes.dialog.fields.validity_period") + " : "
                                    }
                                    {
                                        overtimes.validity_period === "week" ?  `${validity_period_data[overtimes.validity_period]} (${weeks[overtimes.restart_week]})` : overtimes.validity_period === "fortnight" ? `${validity_period_data[overtimes.validity_period]} (${dayjs(overtimes.restart_date).format('LLL')})` : validity_period_data[overtimes.validity_period]
                                    }
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => closed()} color='error' variant="contained">{t("general.buttons.close")}</Button>
            </DialogActions>
        </Dialog>
    );
}

export { InfoOvertime };